<script setup>
defineProps({
  title:      { type: String, required: true },
  sub:        { type: String, default: '' },
  clearHref:  { type: String, default: '' },
  clearLabel: { type: String, default: '' },
})
</script>

<template>
  <div class="empty-results">
    <span class="empty-results__icon">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-3.5-3.5" />
      </svg>
    </span>
    <h3 class="empty-results__title">{{ title }}</h3>
    <p
      v-if="sub"
      class="empty-results__sub"
    >{{ sub }}</p>
    <a
      v-if="clearHref"
      :href="clearHref"
      class="empty-results__clear"
    >{{ clearLabel }}</a>
  </div>
</template>

<style scoped>
.empty-results { display: flex; flex-direction: column; align-items: center; text-align: center; padding: clamp(3rem, 8vw, 5rem) 1.5rem; }
.empty-results__icon { display: grid; place-items: center; width: 3.5rem; height: 3.5rem; border-radius: 1rem; background: color-mix(in oklch, var(--accent) 12%, var(--surface)); color: var(--accent); margin-bottom: 1rem; }
.empty-results__icon svg { width: 1.75rem; height: 1.75rem; }
.empty-results__title { font-family: var(--display); font-weight: 800; font-size: clamp(1.25rem, 2.4vw, 1.6rem); color: var(--ink); margin: 0 0 0.4rem; letter-spacing: -0.01em; }
.empty-results__sub { color: var(--inkSoft); font-size: 1.0625rem; line-height: 1.5; margin: 0 0 1.25rem; max-width: 32rem; }
.empty-results__clear { display: inline-flex; padding: 0.6rem 1.3rem; border-radius: 999px; background: var(--accent); color: var(--accentInk); font-family: var(--display); font-weight: 700; font-size: 0.9375rem; text-decoration: none; }
.empty-results__clear:hover { filter: brightness(1.05); }
</style>
